export function getJoinedUniqueIds(ids: number[]): string {
  return [...new Set<number>(ids)].join(':');
}
